import {Component, Inject, Input, OnInit, Optional} from '@angular/core'
import {ImageEditorService} from '../image.editor.service'
import {PreloaderService} from '../../preloader/preloader.service'
import {GGBase, GGImage} from './gg.interface'
import {CacheService} from '../../../services/cache.service'
import {Router} from '@angular/router'
import {environment} from '../../../../../environments/environment'
import {NZ_MODAL_DATA, NzModalRef} from 'ng-zorro-antd/modal'
import {assignModalData} from '../../../utils/modal-data.util'
import {WIZARD_CFG} from '../defaults.data'
import {NotificatorService} from '../../../services/notificator.service'

@Component({
    selector: 'app-global-gallery',
    templateUrl: 'global.gallery.component.html',
    styleUrls: [
        'global.gallery.component.css',
        '../wizard/wizard.component.css'
    ],
    standalone: false
})
export class GlobalGalleryComponent implements OnInit {
  @Input() category: string

  gallery: GGBase[]
  inited: boolean
  dim = {
    Cover: WIZARD_CFG.types.cover.minUploadWidth,
    Advertising: WIZARD_CFG.types['cover-ads'].minUploadWidth,
    'Seat Map': WIZARD_CFG.types.seat_map.minUploadWidth,
    Gallery: WIZARD_CFG.types['gallery-big'].minUploadWidth
  }
  // Search
  searchValue = ''
  filteredGallery: GGBase[] = []
  // pagination
  pageIndex = 1
  pageSize = 10
  displayGallery: GGBase[] = []



  updateToPlaceholder(event: Event) {
    const imgElement = event.target as HTMLImageElement
    imgElement.src = 'assets/common/noimage.png'
  }

  removeMedia(item: GGImage, vendor: GGBase, storage: string) {
    console.log('to-remove: ', item, vendor)
    this.IES.removeImage(item.id, this.category, vendor.vendor.vendorId)
      .then(done => {
        console.log('removed')
        switch (storage) {
          case 'coverImage':
          case 'seatMap':
            vendor.gallery[storage] = null
            break
          case 'gallery':
            vendor.gallery.images = vendor.gallery.images.filter(f => f.id !== item.id)
            break
        }
        this.notify.createTopMessage('Image has been removed', 'success', 3500)
      })
  }

  gotoEdit(item: GGBase) {
    this.modal.close()
    const category = environment.categoryDec2Str(item.vendor.category).plural
    this.router.navigate([`/vendor/${category}/edit/${item.vendor.vendorId}`])
  }

  onImageLoad($event: Event, vendor: GGBase, image: GGImage) {
    const img = event.target as HTMLImageElement
    const width = img.naturalWidth
    const height = img.naturalHeight
    image.realX = width
    image.realY = height
  }

  async init() {
    this.gallery = []
    this.preloader.turnOnPreloader()
    this.preloader.printMessage('Init...')
    const all = await this.IES.getGlobalGallery(this.category)
    console.log('loaded global gallery: ', all)
    for (const item of all) {
      const vendor = await this.CS.getVendorNameByCatAndId(item.vendor)
      item.vendorName = vendor
    }
    this.preloader.turnOffPreloader()
    this.gallery = all
    this.onSearchChange()
    this.updateDisplayGallery()
    this.inited = true
  }


  onSearchChange(): void {
    this.filteredGallery = this.gallery.filter(item =>
      item.vendorName.toLowerCase().includes(this.searchValue.toLowerCase())
    )
    this.pageIndex = 1
    this.updateDisplayGallery()
  }

  updateDisplayGallery(): void {
    const startIndex = (this.pageIndex - 1) * this.pageSize
    const endIndex = startIndex + this.pageSize
    this.displayGallery = this.filteredGallery.slice(startIndex, endIndex)
  }

  onPageIndexChange(index: number): void {
    this.pageIndex = index
    this.updateDisplayGallery()
    environment.scrollToTop()
  }

  constructor(
    private IES: ImageEditorService,
    private preloader: PreloaderService,
    private modal: NzModalRef,
    private CS: CacheService,
    private router: Router,
    private notify: NotificatorService,
    @Optional() @Inject(NZ_MODAL_DATA) modalData?: Partial<GlobalGalleryComponent>
  ) {
    assignModalData(this, modalData)
  }

  ngOnInit() {
    console.log('GG: cat: ', this.category)
    // Avoid NG0100: preloader.active must not flip during the current CD pass.
    queueMicrotask(() => this.init())
  }
}
